import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as triangle from '../triangle.js';

export {
    init,
}

const POIs = [
    {
        name: 'hey-1',
        position: { x: 34, y: 24, z: 0 },
        color: 'white',
        sound: {
            name: 'hey-1',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'hey-2',
        position: { x: 35, y: 25, z: 0 },
        color: 'white',
        sound: {
            name: 'hey-2',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'hey-3',
        position: { x: 36, y: 26, z: 0 },
        color: 'white',
        sound: {
            name: 'hey-3',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'hey-4',
        position: { x: 37, y: 27, z: 0 },
        color: 'white',
        sound: {
            name: 'hey-4',
            gain: 0,
        },
        collision: {
            radius: 1,
        },
        onEnter() {
            triangle.drop('stonehenge-triangle-4', this.position, {
                collisionRadius: 0.5,
                offset: { x: 1, y: 1 },
                delay: 1,
            });
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'hey-1', url: new URL('../../sound/Hey1.wav', import.meta.url) },
    { name: 'hey-2', url: new URL('../../sound/Hey2.wav', import.meta.url) },
    { name: 'hey-3', url: new URL('../../sound/Hey3.wav', import.meta.url) },
    { name: 'hey-4', url: new URL('../../sound/Hey4.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
